import { Link } from "react-router-dom";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0b0c10] p-6">
      <div className="telesis-panel rounded p-8 max-w-md text-center">
        <p className="telesis-eyebrow">Payment cancelled</p>
        <p className="text-slate-300 mt-3">No worries — you can subscribe later.</p>
        <Link to="/feed" className="mt-4 inline-block text-yellow-400 underline">Back to feed</Link>
      </div>
    </div>
  );
}
